export default {
    applyingDate: null,
    signingDate: null
};
